import {
    LOAD_INSTORE_SETTINGS_SUCCESS,
    UPDATE_INSTORE_SETTINGS_SUCCESS,
    RESET_INSTORE_SETTINGS,
    GET_ALL_RESTAURANT_MENUS
} from '../../../../actions/types';

const INITIAL_STATE = {
    restaurantMenus: []
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_INSTORE_SETTINGS_SUCCESS:
            return { ...state, ...action.payload };
        case UPDATE_INSTORE_SETTINGS_SUCCESS:
            return { ...state, ...action.payload };
        case GET_ALL_RESTAURANT_MENUS:
            return { ...state, restaurantMenus: action.payload};
        case RESET_INSTORE_SETTINGS:
            return INITIAL_STATE;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/service/InStoreReducer.js